export function charAt(value: string, position?: number): string | null {
    return position ? value?.charAt(position) : null;
}

export function toLowerCase(value: string): string {
    return value?.toLowerCase();
}

export function toUpperCase(value: string): string {
    return value && value?.toUpperCase();
}

export function convertCamelCaseToSeparateWords(str: string): string {
    return str.split(/(?=[A-Z])/).join(' ');
}

export function isString(value: any): value is string {
    return typeof value === 'string' || value instanceof String;
}

export function removeHTMLTags(value: string): string {
    return value.replace(/<[^>]*>?/gm, '');
}

export function htmlHasTextOrImg(value: string): boolean {
    return value.replace(/<((?!img)[^>])+>/gm, '')?.length > 0;
}

export function concatTextAtPosition(text: string, valueToConcat: string, position: number): string {
    const firstHalf = text.substring(0, position);
    const secondHalf = text.substring(position);

    const result = firstHalf.concat(valueToConcat).concat(secondHalf);
    return result;
}

export function StringIsNumber(value: string): boolean {
    return isNaN(Number(value)) === false;
}

export function removeQuotes(str: string): string {
    if ((str.startsWith('"') && str.endsWith('"')) || (str.startsWith("'") && str.endsWith("'"))) {
        return str.slice(1, -1);
    }
    return str;
}

export function stringIsNullOrEmpty(value?: string): boolean {
    return !value || value === '';
}
